// ============================================
// Utils - Toast Notifications (ES6)
// Toast 알림 기능 - Modern Design
// ============================================

let toastTimeout = null;

// 타입별 아이콘 SVG
const TOAST_ICONS = {
  success: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>`,
  error: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>`,
  warning: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>`,
  info: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>`
};

export function showToast(message, type = 'info') {
  const toast = document.getElementById('toast');
  if (!toast) return;

  if (toastTimeout) {
    clearTimeout(toastTimeout);
  }

  let typeClass = 'info';
  if (type === 'error' || type === true) typeClass = 'error';
  else if (type === 'success') typeClass = 'success';
  else if (type === 'warning') typeClass = 'warning';

  const icon = TOAST_ICONS[typeClass] || TOAST_ICONS.info;

  toast.innerHTML = `
    <span class="toast-icon">${icon}</span>
    <span class="toast-message">${message}</span>
    <div class="toast-progress"></div>
  `;
  toast.className = `toast show ${typeClass}`;

  toastTimeout = setTimeout(() => {
    toast.classList.remove('show');
    toastTimeout = null;
  }, 2000);
}

// window 노출 제거됨 (2026-01-06) - import로 사용
